
import type { IAnalysisDirectory, IHistoryResponse, IProject } from '@/types';
import { container } from '@eureka/services';
import type { ICoreDataWrapper } from '@eureka/services/src/exception';

function handleResponse(res: ICoreDataWrapper<any>) {
    return res.data;
}

export function getProjectHistory(projectId: string, type: 'SESSION_CHAT' | 'MODEL_ANALYSIS'): Promise<any> {
    return container.RnDHttp.get<ICoreDataWrapper<IHistoryResponse>>({
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/air/history/records`,
        params: {
            business_id: projectId,
            session_type: type,
        },
    }).then(handleResponse)
}

export function analysisDirectory(projectId: string, query: string, directory?: IAnalysisDirectory[]) {
    return container.RnDHttp.post<ICoreDataWrapper<IAnalysisDirectory[]>>({
        url: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/analysis-directory`,
        data: {
            project_id: projectId,
            query,
            directory_list: directory,
        },
    }).then(handleResponse)
}

export function createProject(projectId: string) {
    const url = `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/project/create`
    return container.RnDHttp.post<ICoreDataWrapper<IProject>>({
        url,
        data: {
            project_id: projectId,
        },
    }).then(handleResponse)
}
